'use client';

import { LoginPage } from '@risk-first/ui-login-page';
import { useAuthProviderContext } from '@bss-portfolio-view-ui/next-js-common-ui-auth';
import { getApplicationName } from '@bss-portfolio-view-ui/next-js-common-util-application';
import { MoodysLogo, ProductLogo } from './page.styles';

export default function Login() {
  const { returnTo } = useAuthProviderContext();

  return (
    <LoginPage
      headerLogo={<MoodysLogo height="24.82" width="148.4" />}
      productLogo={<ProductLogo>{getApplicationName()}</ProductLogo>}
      onLoginClick={() => {
        window.location.href = `/auth/login${returnTo ? '?returnTo=' + encodeURIComponent(returnTo) : ''}`;
      }}
      variant="gradient"
    />
  );
}
